import { Box, Stack, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { FormattedMessage, FormattedNumber } from "react-intl";

function PricesRecreationalCenter() {
  return (
    <Stack spacing="1.5rem">
      <Box>
        <Text fontSize="1.25rem" fontWeight={500} lineHeight="1.75rem">
          <FormattedMessage defaultMessage="Tarifs à la journée" />
        </Text>

        <Table>
          <Tbody>
            <Tr>
              <Td width="15%" borderBottomWidth="2px" pl="0"></Td>

              <Td colSpan={2} borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Résidents de Golbey" />
                </Text>
              </Td>

              <Td colSpan={2} borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Extérieur" />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="15%" borderBottomWidth="2px" pl="0"></Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Plein tarif" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Tarif réduit" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Plein tarif" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Tarif réduit" />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="15%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="1 jour" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={20} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={19} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={21} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={20} style="currency" currency="EUR" />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="15%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="2 jours" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={38} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={36} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={40} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={38} style="currency" currency="EUR" />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="15%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="3 jours" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={54} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={51} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={57} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={54} style="currency" currency="EUR" />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="15%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="4 jours" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={65} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={61} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={69} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={65} style="currency" currency="EUR" />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="15%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="5 jours" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={75} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={70} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={80} style="currency" currency="EUR" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={75} style="currency" currency="EUR" />
                </Text>
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </Box>

      <Box>
        <Text fontSize="1.25rem" fontWeight={500} lineHeight="1.75rem">
          <FormattedMessage defaultMessage="Suppléments" />
        </Text>

        <Table>
          <Tbody>
            <Tr>
              <Td width="15%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Repas" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber
                    value={5.7}
                    style="currency"
                    currency="EUR"
                  />
                </Text>
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </Box>
    </Stack>
  );
}

export default PricesRecreationalCenter;
